import React from 'react';
import { Field } from 'formik';

import styles from './executiveManagementFormStyles';

import ImageField from 'buyside/components/presentation/Form/Field/ImageField/imageField';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import AddRemoveForm from 'buyside/components/presentation/Form/AddRemoveForm/addRemoveForm';

import { defaultExecutivePhotoUrl } from 'buyside/util/urlHelper';

// NOTE: make sure to update the appropriate schema in util/allocatorProfileShowPageValidationSchemata

const ExecutiveManagementForm = () => {
  const renderExecutive = (executivePath, executive) => {
    const { imageData, croppedImageData, photoUrl, photoProfileUrl, defaultPhoto } = executive;
    return (
      <div className={styles.executive}>
        <div className={styles.executivePhoto}>
          <Field
            component={ImageField}
            name={executivePath}
            title="photo"
            image={imageData || photoUrl}
            croppedImage={croppedImageData || photoProfileUrl}
            defaultImage={defaultPhoto}
            isCircular
          />
        </div>
        <div className={styles.executiveMainArea}>
          <div>
            <Field component={InputField} name={executivePath + '.name'} label="Name" />
            <Field
              component={InputField}
              name={executivePath + '.bio'}
              type="textarea"
              label="Bio"
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <AddRemoveForm
        title="Executives"
        attr="allocatorProfile.executives"
        renderItem={renderExecutive}
        itemName="Executive"
        blankItem={{
          name: '',
          bio: '',
          photoUrl: defaultExecutivePhotoUrl(),
          photoProfileUrl: defaultExecutivePhotoUrl(),
          defaultPhoto: defaultExecutivePhotoUrl()
        }}
      />
    </div>
  );
};

export default ExecutiveManagementForm;
